<template>
  <a @click="triggerDrawer">
    <slot>
      <MTooltip>
        <template v-slot:trigger>
          <a class="mr-2">
            <MIcon name="tachometer-alt" />
          </a>
        </template>
        {{ $tc('meter') }} {{ $tc('info') }}
      </MTooltip>
    </slot>
    <FlotoDrawer :open="isDrawerOpen" class="flex" @hide="handleHide">
      <template v-slot:title>
        {{ $t('meter') }} {{ $tc('info') }}: {{ resource.name }}
      </template>
      <MRow class="items-center px-4" :gutter="0">
        <div class="flex flex-1 items-center">
          <FlotoForm
            ref="formRef"
            class="flex items-center"
            @submit="handleSearchSubmit"
          >
            <MCol auto-size class="pr-2">
              <FlotoFormItem
                :label="$t('from')"
                :rules="{
                  required: true,
                  nonzero: true,
                  // eslint-disable-next-line
                  max_date: endDate,
                }"
              >
                <FlotoDatePicker
                  v-model="startDate"
                  :allow-clear="false"
                  :max-date="endDate"
                  :show-time="false"
                />
              </FlotoFormItem>
            </MCol>
            <MCol auto-size class="px-2">
              <FlotoFormItem
                :rules="{
                  required: true,
                  nonzero: true,
                  // eslint-disable-next-line
                  min_date: startDate,
                }"
                :label="$t('to')"
              >
                <FlotoDatePicker
                  v-model="endDate"
                  :allow-clear="false"
                  :min-date="startDate"
                  :show-time="false"
                  end-of-day
                />
              </FlotoFormItem>
            </MCol>
            <template v-slot:submit>
              <span />
            </template>
          </FlotoForm>
          <MButton class="mt-2 ml-3" :loading="processing" @click="submitForm">
            {{ $t('search') }}
          </MButton>
        </div>
      </MRow>
      <MDivider />
      <MRow>
        <MCol v-if="usageInfo.usageDuration" :size="12">
          <BoxNode
            :title="`${$tc('total')} ${$tc('usage_duration')}`"
            :shadow="false"
            :count="usageInfo.usageDuration | duration"
          />
        </MCol>
      </MRow>
      <MDivider v-if="usageInfo.usageDuration" />
      <PaginatedCrud
        :key="renderCount"
        ref="list"
        as-table
        :scrollable="false"
        immediate
        :fetch-fn="getSoftwareUsage"
        :columns="tableColumns"
        :selectable="false"
        :show-no-data="false"
      >
        <template v-slot:form>
          <span />
        </template>
        <template v-slot:dayWiseUsage="{ item }">
          <td class="text-ellipsis">
            {{ item.dayWiseUsage | datetime(undefined, false) }}
          </td>
        </template>
        <template v-slot:usageDuration="{ item }">
          <td class="text-ellipsis">
            {{ item.usageDuration | duration }}
          </td>
        </template>
        <!-- <template v-slot:lastUsedTime="{ item }">
          <td class="text-ellipsis">
            <template v-if="item.lastUsedTime">
              {{ item.lastUsedTime | datetime }}
            </template>
            <template v-else>---</template>
          </td>
        </template> -->
        <template v-slot="slotData">
          <slot v-bind="slotData"></slot>
        </template>
      </PaginatedCrud>
      <template v-slot:trigger>
        <span />
      </template>
    </FlotoDrawer>
  </a>
</template>

<script>
import BoxNode from '@modules/asset-management/components/discovery-component/discovery-service/box-node'
import Moment from 'moment'
import PaginatedCrud from '@components/paginated-crud'
import { getSoftwareUsageApi } from '../../software-meter-api'
export default {
  name: 'SoftwareMeterUsageDrawer',
  components: { PaginatedCrud, BoxNode },
  props: {
    resourceId: { type: Number, required: true },
    agentId: { type: Number, required: true },
    resource: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    this.tableColumns = [
      // {
      //   name: `${this.$tc('start_time')}`,
      //   key: 'startTime',
      // },
      // {
      //   name: `${this.$tc('end_time')}`,
      //   key: 'endTime',
      // },
      // {
      //   name: `${this.$tc('usage_count')}`,
      //   key: 'usageCount',
      // },
      {
        name: `${this.$tc('date')}`,
        key: 'dayWiseUsage',
      },
      {
        name: `${this.$tc('usage_duration')}`,
        key: 'usageDuration',
      },
      // {
      //   name: `${this.$tc('last_used')}`,
      //   key: 'lastUsedTime',
      // },
    ]
    return {
      isDrawerOpen: false,
      processing: false,
      startDate: Moment().subtract(7, 'days').startOf('day').unix() * 1000,
      endDate: Moment().endOf('day').unix() * 1000,
      renderCount: 1,
      usageInfo: {},
    }
  },
  methods: {
    submitForm() {
      if (this.processing) {
        return
      }
      this.$refs.formRef.submit()
    },
    handleSearchSubmit() {
      this.renderCount += 1
    },
    getSoftwareUsage() {
      this.processing = true
      return getSoftwareUsageApi(this.resourceId, this.agentId, {
        startDate: this.startDate,
        endDate: this.endDate,
      })
        .then((data) => {
          this.processing = false
          this.usageInfo = { usageDuration: data.usageDuration }
          return data.items || []
        })
        .catch(() => {
          this.processing = false
          this.usageInfo = {}
        })
    },
    triggerDrawer() {
      setTimeout(() => {
        this.isDrawerOpen = true
      }, 200)
    },
    handleHide() {
      setTimeout(() => {
        this.isDrawerOpen = false
      }, 400)
    },
  },
}
</script>
